import { createFileRoute } from "@tanstack/react-router";
import PropUploadTab from "lib/components/debug/PropUploadTab";
import getPageTitle from "lib/utils/getPageTitle";
import { Helmet as Head } from "react-helmet-async";
import withAuthentication from "../../components/withAuthentication";

function PropAwsBatch() {
  return (
    <>
      <Head>
        <title>{getPageTitle("Prop AWS Batch")}</title>
      </Head>

      <div className="ui" style={{ padding: "10px" }}>
        <a href="/debug/prop-aws-admin">&lt;&lt; Back to admin</a>
        <div style={{ padding: "10px 0" }}>
          <PropUploadTab />
        </div>
      </div>
    </>
  );
}

export const Route = createFileRoute("/debug/prop-aws-batch")({
  component: withAuthentication(PropAwsBatch, { superAdmin: true }),
});
